import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Col,
  Row,
  Radio,
  Input,
  Checkbox,
  Form,
  Button,
  InputNumber,
  message,
} from "antd";
import DATA from "./questionform";
// import { getStyleProperties } from "../../../utils/CustomFunc";
// import axios from "../../utils/BasicAuthAPI";
import "./storm.css";
import queryString from "query-string";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import liracrypt from "../Liracrypt/liracrypt";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import SessionError from "../ApiErrorComp/SessionError";
import { getStyleProperties } from "../../utils/CustomFunc";
import FormElement from "./FormElement";
import ButtonPicker from "../ReportFormGenerator/Button/Button";
import AdvanceButton from "../ReportFormGenerator/AdvanceButton/AdvanceButton";
import moment from "moment";


const STORM = (props) => {
  const { docNo } = useParams();
  let history = useHistory();
  let location = useLocation();
  const params = queryString.parse(location.search);
  const [stormResponse, setStormResponse] = useState(null);
  const [examDetail, setExamDetail] = useState(null);
  const [loginError, setLoginError] = useState(false);
  const [defaultValue, setDefaultValue] = useState(null);
  const { TextArea } = Input;

  props.setPageHeader("Assessment");
  const [form] = Form.useForm();

  useEffect(() => {
    fetchAPI();
    // setStormResponse(DATA);
  }, []);

  const fetchAPI = () => {
    liracrypt
      .get("/storm", { docNo: docNo })
      .then(({ data }) => {
        
        setStormResponse(data);
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const postData = (data) => {
    const datetimes = stormResponse.data.filter(
      (obj) =>
        ["dateTimePicker", "datePicker"].indexOf(obj.typ) > -1 && obj.format
    );
    const rangePicker = stormResponse.data.filter(
      (obj) => ["rangePicker"].indexOf(obj.typ) > -1
    );

    for (const idx in rangePicker) {
      data = {
        ...data,
        [rangePicker[idx]["_id"]]: [
          moment(data[rangePicker[idx]["_id"]][0]).format(
            rangePicker[idx].format ? rangePicker[idx].format : "YYYY-MM-DD"
          ),
          moment(data[rangePicker[idx]["_id"]][1]).format(
            rangePicker[idx].format ? rangePicker[idx].format : "YYYY-MM-DD"
          ),
        ],
      };
    }

    for (const idx in datetimes) {
      data = {
        ...data,
        [datetimes[idx]["_id"]]: moment(data[datetimes[idx]["_id"]]).format(
          datetimes[idx].format
        ),
      };
    }

    liracrypt
      .post(stormResponse?.config?.buttons[0].url, { docNo: docNo, ans: data })
      .then(({ data }) => {
        
        // setStormResponse(data);
        message.success(
          stormResponse?.config?.buttons[0].msg
            ? stormResponse?.config?.buttons[0].msg
            : "Submitted Successfully"
        );
        if (stormResponse?.config?.buttons[0].action === "clearForm") {
          form.resetFields();
          
        }
        if (stormResponse?.config?.buttons[0].action === "blankPage") {
          setStormResponse(null);
        }
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const onFinishFailed = (e) => {
    
  };
  const onFinish = (data) => {
    postData(data);
  };

  const formStyle = (formConfig) => {
    const style = {
      width: formConfig.formWidth ? formConfig.formWidth : "1000px",
      background: `linear-gradient(to right, ${formConfig.DivBackgroundColor[0]}, ${formConfig.DivBackgroundColor[1]})`,
      align: formConfig.DivAlignment ? formConfig.DivAlignment : "center",
      marginLeft: formConfig.LeftMargin ? formConfig.LeftMargin : "0px",
      paddingLeft: formConfig.InnerLeftPadding
        ? formConfig.InnerLeftPadding
        : "15px",
      paddingRight: formConfig.InnerRightPadding
        ? formConfig.InnerRightPadding
        : "15px",
    };

    if (formConfig["line-color"]) {
      style["borderBottom"] = `1px solid formConfig["line-color"]`;
    }

    return style;
  };


  const auxLines = ({ aux1, aux2, aux3, aux4 }) => (
    <div className="aux-lines">
      {
        aux1 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux1),
            padding: stormResponse?.config?.aux1["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux1.prefix}</span>
            <span>{aux1}</span>
          </p>
        )
      }
      {
        aux2 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux2),
            padding: stormResponse?.config?.aux2["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux2.prefix}</span>
            <span>{aux2}</span>
          </p>
        )
      }
      {
        aux3 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux3),
            padding: stormResponse?.config?.aux3["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux3.prefix}</span>
            <span>{aux3}</span>
          </p>
        )
      }
      {
        aux4 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux4),
            padding: stormResponse?.config?.aux4["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux4.prefix}</span>
            <span>{aux4}</span>
          </p>
        )
      }
    </div>
  );

  const QusAns = (question, form) => {
    let { aux1, aux2, aux3, aux4 } = question;
    return (
      <>
        <Col
          key={"qus" + question._id + question.qno}
          span={24}
          style={{ padding: "10px 10px" }}
        >
          <p
            className="question"
            style={{
              ...getStyleProperties(stormResponse?.config?.question),
              padding: stormResponse?.config?.question["row-padding"],
            }}
          >
            <span>{question.qno}:</span> {question.qtn}
          </p>
          
          {auxLines({ aux1, aux2, aux3, aux4 })}

          <div
            style={{
              ...getStyleProperties(stormResponse?.config["answer "]),
              padding: stormResponse?.config["answer "]["row-padding"],
            }}
          >
            <FormElement elemData={question} form={form} />
          </div>
        </Col>
      </>
    );
  };

  const getButton = (button, form) => {
    return (
      <>
        <Col span={24} style={{ padding: "10px 10px" }}>
          <p
            className="question"
            style={{
              ...getStyleProperties(stormResponse?.config?.rows),
              padding: stormResponse?.config?.rows["row-padding"],
            }}
          >
            {/* <span>{question.qno}:</span> {question.qtn} */}
          </p>

          {/* <FormElement elemData={question} form={form} /> */}
        </Col>
      </>
    );
  };

  const getFooter = (footer, footerNotes) => {
    return (
      <Row className="storm-footer">
        <Col
          span={24}
          style={{
            ...getStyleProperties(footer),
            padding: footer["row-padding"],
          }}
        ></Col>
        <Col span={24}>
          <ul style={{ listStyle: "none", paddingLeft: "0px" }}>
            {footerNotes.map((fItem, index) => {
              return (
                <li
                  style={{
                    ...getStyleProperties(fItem),
                    padding: fItem["row-padding"]
                      ? fItem["row-padding"]
                      : "5px",
                  }}
                >
                  {fItem["text"]}
                </li>
              );
            })}
          </ul>
        </Col>
      </Row>
    );
  };

  const getHeader = (header, title, subtitle) => {
    return (
      <Row
        className="storm-header"
        style={{
          ...getStyleProperties(header),
          padding: header["row-padding"],
        }}
      >
        <Col
          span={24}
          style={{
            ...getStyleProperties(title),
            textAlign: title["align"] ? title["align"] : "left",
            padding: title["row-padding"] ? title["row-padding"] : 0,
          }}
        >
          <span>{title["title-label"]}</span>
        </Col>
        <Col
          span={24}
          style={{
            ...getStyleProperties(subtitle),
            padding: subtitle["row-padding"] ? subtitle["row-padding"] : 0,
            textAlign: subtitle["align"] ? subtitle["align"] : "left",
          }}
        >
          <span>{subtitle["title-label"]}</span>
        </Col>
      </Row>
    );
  };
  return (
    <React.Fragment>
      {stormResponse && stormResponse.config && (
        <Row className="storm-custom">
          <Col span={24}>
            {getHeader(
              stormResponse.config?.headers,
              stormResponse.config?.formTitle,
              stormResponse.config?.formSubTitle
            )}
          </Col>
          <Col span={24}>
            <div style={formStyle(stormResponse.config.formConfig)}>
              <Form
                name="ReportForm"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                layout="horizontal"
                colon={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                size="large"
              >
                {stormResponse.data.map((question) => QusAns(question, form))}
                <Col span={24} style={{ padding: "10px 10px" }}>
                  {stormResponse.config.buttons.map((btn) => (
                    <AdvanceButton
                      form={form}
                      label={btn.label}
                      type={btn.type}
                      disabled={btn.disabled}
                      confirmationPopUp={btn.confirmationPopUp}
                    />
                  ))}
                </Col>
              </Form>
            </div>
          </Col>
          <Col span={24}>
            {getFooter(
              stormResponse.config?.footer,
              stormResponse.config?.footerNotes
            )}
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};
export default STORM;
